import { Fragment, useCallback, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import FormInstitution, { InstitutionForm } from 'system/components/institution/form';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { Institution } from 'shell/models/institution';
import { HttpResponse } from 'shell/models/http-response';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonInstitutionCrumbs } from '../constants';
import { toast } from 'react-toastify';

const InstitutionEditPage = (): React.ReactElement => {
  const params = useParams();
  const {
    put: updateInstitution,
    data,
    get: getInstitution,
    loading,
    error,
  } = useHttpFetch<HttpResponse<Institution>>(`${__MANAGEMENT_API_URL__}/enti/${params.id}`, {
    data: {},
  });

  const institution: InstitutionForm = useMemo(() => {
    const ente = data?.payload;
    if (!ente || !!error) {
      return {
        istat: '',
        officeNumber: 0,
        province: '',
        type: '',
        mayor: '',
        mayorFiscalCode: '',
        code: '',
        description: '',
        anpr: false,
        name: null,
      };
    }
    return {
      istat: ente.codiceIstat,
      name: {
        description: ente.nome?.trim(),
      },
      officeNumber: ente.numeroUfficiStatoCivile,
      province: ente.provincia,
      code: ente.key?.codice,
      mayor: ente.sindaco ? ente.sindaco : '',
      mayorFiscalCode: ente.codFiscaleSindaco ? ente.codFiscaleSindaco : '',
      description: '',
      anpr: false,
      lastUpdate: ente.note,
      direction: ente.descrizioneDirezione,
    };
  }, [data]);

  const navigate = useNavigate();
  const onSubmit = useCallback(
    (formValues) => {
      updateInstitution({
        codiceIstat: formValues.istat || 0,
        numeroUfficiStatoCivile: formValues.officeNumber || 0,
        nome: `Comune di ${formValues.name.description}` || '',
        sindaco: formValues.mayor || '',
        codFiscaleSindaco: formValues.mayorFiscalCode || '',
        provincia: formValues.province || '',
        note: formValues.lastUpdate,
        descrizioneDirezione: formValues.direction,
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/enti');
      });
    },
    [updateInstitution, navigate]
  );

  useEffect(() => {
    getInstitution();
  }, [params.id]);

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonInstitutionCrumbs, { name: 'Modifica Ente' }]} />
      {loading && !data ? null : (
        <FormInstitution
          title="Modifica Ente"
          onOk={onSubmit}
          onCancel={() => {
            navigate('/sistema/enti');
          }}
          initialValues={institution}
        />
      )}
    </Fragment>
  );
};

InstitutionEditPage.displayName = 'Institution Edit page component';

export default InstitutionEditPage;
